import React, { useState } from "react";
import ActualCycleTimeBarChart from "./ActualCycleTimeBarChart";
import FactoryFilters from "../filters/FactoryFilters";
import { useDispatch, useSelector } from "react-redux";
import { reportActions } from "../../../_redux/actions";

const ActualCycleTimeReport = (props) => {
    const dispatch = useDispatch();
    const sbuListState = useSelector((state: any) => state.factories.sbuList);
    const initialReportData = {
        factory: '',
        plant: '',
        style: '',
        categories: [],
        dataSets: [{ name: 'SSV', data: [] }
            , { name: 'TCT-1', data: [] }]
    };

    const [reportData, setReprtData] = useState(initialReportData);
    const [reportDataExists, setReportDataExists] = useState(false);
    let factoryId: number = null;
    let modules: string[] = null;

    const loadReportData = () => {
        setReportDataExists(false);
        dispatch(reportActions.getTotalCycleTimes(factoryId
            , modules
            , (res) => {
                if (res && res.length > 0) {
                    //order by module
                    res.sort(function (a, b) {
                        return a.studyHeader.module < b.studyHeader.module ? -1 : 1;
                    });
                    let rptData = {
                        factory: res[0].studyHeader.factoryCode,
                        plant: res[0].studyHeader.plantCode,
                        style: res[0].studyHeader.style,
                        categories: [],
                        dataSets: [{ name: 'SSV', data: [] }
                            , { name: 'TCT-1', data: [] }]
                    };
                    let maxCycleCount = res.length > 1 ? res.reduce((a, b) => {
                        let a_value = 0;
                        if (typeof a == "number") {
                            a_value = a;
                        } else {
                            a_value = a.totalCycleTimeImprovements ? a.totalCycleTimeImprovements.length : 0;
                        }
                        return Math.max(a_value, b.totalCycleTimeImprovements ? b.totalCycleTimeImprovements.length : 0);
                    }) : (res[0].totalCycleTimeImprovements ? res[0].totalCycleTimeImprovements.length : 0);
                    for (const item of res) {
                        rptData.categories.push(item.studyHeader.module + ' - ' + item.studyHeader.style);
                        rptData.dataSets[0].data.push(item.totalSSV.toFixed(1));
                        rptData.dataSets[1].data.push(item.totalActualTime.toFixed(1));
                        for (let i = 0; i < maxCycleCount; i++) {
                            let tctCycleName = 'TCT-' + (i + 2);
                            let dataItem = rptData.dataSets.find(itm => {
                                return itm.name === tctCycleName;
                            });
                            let cycleItem = item.totalCycleTimeImprovements ? item.totalCycleTimeImprovements[i] : null;
                            if (!dataItem) {
                                dataItem = { name: tctCycleName, data: [] };
                                rptData.dataSets.push(dataItem);
                            }
                            dataItem.data.push(cycleItem ? cycleItem.totalActualTime.toFixed(1) : null);
                        }
                    }
                    setReprtData(rptData);
                    setReportDataExists(true);
                } else {
                    setReprtData(initialReportData);
                }
            }
            , () => {

            }));
    }

    const onFilterClear = () => {
        setReportDataExists(false)
    }

    const onFilterChange = (facId: any, modls: any) => {
        factoryId = facId ? facId.value : null;
        modules = modls ? modls.value : null;
        loadReportData();
    }

    return (
        <React.Fragment>
            <FactoryFilters
                onFilterClear={() => onFilterClear()}
                onFilterChange={(facId, mols) => onFilterChange(facId, mols)}
                sbus={sbuListState.data} />

            {reportDataExists &&
                (<ActualCycleTimeBarChart data={{ reportData }} width='100%' height={500} />)
            }
        </React.Fragment>
    )
}

export default ActualCycleTimeReport;

